import Lottie from 'lottie-react';
import React from 'react';
import { FaLocationDot } from 'react-icons/fa6';
import NoDataAnimation from "../../assets/animations/No Result Green theme.json"

const fakeData = [
  { title: 'Arabic Desert Film', role: 'Casting Actor' },
  { title: 'Hidden Spy History', role: 'Casting Actor' },
  { title: 'Urban Nights', role: 'Director & Producer' },
  { title: 'Arabic Desert Film', role: 'Camera Man' },
  { title: 'Hidden Spy History', role: 'Photo Grapher' },
  { title: 'Hidden Spy History', role: 'Camera Man' },
  { title: 'Secret Mission', role: 'Editor' },
  { title: 'Urban Nights', role: 'Casting Actor' },
  { title: 'War Chronicles', role: 'Camera Man' },
];

const imageUrl =
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQsWUGye5k6Rbtd5VQZaypLJYiZ7h6O8inP9VSDrGBdOBAfjchTGAB1Q0Bh2zf9COdU1A&usqp=CAU';

   const renderJobCard = (job) => {
      console.log("job ---- ", job);
      return (
        <div
          key={job._id}
          className="inter-font d-flex justify-content-between align-items-center my-3 border-bottom pb-3"
        >
          <div className="inter-font d-flex align-items-start">
            {/* <img
              src={profile}
              className="inter-font rounded-circle mt-1"
              style={{ width: 54, height: 54, objectFit: "cover" }}
              alt="Profile"
            /> */}
            <div className="inter-font mt-1 ms-3">
              <h5 className="inter-font inter-font mb-1" style={{ fontSize: "17px" }}>
                {job.title}
              </h5>
              <p className="inter-font m-0 mb-1 inter-font" style={{ fontSize: "16px" }}>
                {job.company}
              </p>
              <p className="inter-font inter-font m-0 text-muted">
                <FaLocationDot className="inter-font me-1 text-dark" />
                {job.location}
              </p>
            </div>
          </div>
          {/* <div className="inter-font position-relative">
            <HiOutlineDotsVertical
              fontSize={23}
              className="inter-font cursor-pointer"
              onClick={() =>
                setOpenMenuId(openMenuId === job._id ? null : job._id)
              }
            />
            {openMenuId === job._id && (
              <div
                className="inter-font position-absolute bg-white shadow rounded p-2"
                style={{ top: "30px", right: 0, zIndex: 10 }}
              >
                <div
                  className="inter-font d-flex align-items-center mb-2 cursor-pointer"
                  onClick={() => {
                    setEditJobData(job);
                    setEditForm({
                      title: job.title,
                      company: job.company,
                      location: job.location,
                    });
                  }}
                >
                  <FaEdit className="inter-font me-2 text-primary" />
                  <span>Edit</span>
                </div>
                <div
                  className="inter-font d-flex align-items-center cursor-pointer"
                  onClick={() =>
                    setConfirmDeleteJob({ id: job._id, title: job.title })
                  }
                >
                  <FaTrash className="inter-font me-2 text-danger" />
                  <span>Delete</span>
                </div>
              </div>
            )}
          </div> */}
        </div>
      );
    };

const Projects = ({projectData}) => {
  console.log("projectData", projectData)
  return (
    <div
      className="container"
      style={{
        maxHeight: '509px',
        overflowY: 'auto',
        // paddingRight: '8px',
      }}
    >
      <div className="row">
        {/* {projectData?.map((item, index) => (
          <div
            className="col-md-4 mb-4 d-flex justify-content-center"
            key={index}
          >
            <div
              style={{

  
                // padding: '16px',
                // width: '210px',
                textAlign: 'start',

              }}
            >
              <img
                src={imageUrl}
                alt={item.title}
                style={{
                  width: '178px',
                  height: '178px',
                  objectFit: 'cover',
                  borderTopLeftRadius: '12px',
                  borderTopRightRadius: '12px',
                //   marginBottom: '12px',
                }}
              />
              <div className='p-2'  style={{
                backgroundColor: '#FDF7F5',
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
                // padding: '5px',
                // width: '210px',
                textAlign: 'start',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
              }} >

              <h5 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '4px',  color: '#373636'}}>
                {item.title}
              </h5>
              <p style={{ fontSize: '12px', color: '#000000', margin: 0 }}>
                {item.role}
              </p>
              </div>
            </div>
          </div>
        ))} */}


      </div>
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {projectData.length === 0 ? (
                  <div className="d-flex flex-column align-items-center py-5">
                  <div style={{ width: 200 }}>
                    <Lottie animationData={NoDataAnimation} loop={true} />
                  </div>
                  </div>
                  ) : (
                    projectData.map(renderJobCard)
                  )}
                </div>
    </div>
  );
};

export default Projects;
